export enum SideNavVariants {
  Expanded = "Expanded",
  Colapsed = "Colapsed",
}
